<template>
  <div id="app" class="fullscreen">
    <template v-if="mobile">
      <div v-if="!loading_finished" class="loading-overlay">
        <div class="overlay-top-image"><img src="./assets/images/Favicon_Logo.svg" alt="" /></div>
        <div class="overlay-progress-full"></div>
        <div class="overlay-progress-bar" :style="{ width: 58 * ucitane_slike + '%' }"></div>
        <div class="overlay-bottom-image"><img src="./assets/images/Knauf_Insulation_Logo.svg" alt="" /></div>
      </div>
      <div class="invisible">
        <img ref="img_cache" v-for="img in loaded_images" :src="img" alt :key="img" />
      </div>
      <div class="main-container" id="main_container">
        <div v-if="show_terms" class="terms">
          <div class="top">
            <div class="left">{{ data.app_welcome.title }}</div>
            <div class="right">
              <img src="./assets/images/close.svg" @click="show_terms = false" />
            </div>
          </div>
          <div class="bottom">
            <div class="inner">
              <div class="row">
                <div class="left">{{ data.app_terms.title }}</div>
                <div class="right">
                  <img
                    src="./assets/images/external_link_symbol_blue.svg"
                    @click="goto_url(data.app_uslovi_koriscenja.title)"
                  />
                </div>
              </div>
              <div class="row">
                <div class="left">{{ data.app_privacy.title }}</div>
                <div class="right">
                  <img
                    src="./assets/images/external_link_symbol_blue.svg"
                    @click="goto_url(data.app_politika_privatnosti.title)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="app-header" id="app_header">
          <div class="left" style="max-width: 0; overflow: hidden;">
            <img src="./assets/images/Hamburger.svg" alt="Menu" />
          </div>
          <div class="middle">
            <img src="./assets/images/KI logo.svg" alt="Logo" />
          </div>
          <div class="right">
            <span
              :class="{ active: data.app_language.value === data.loc_country.value }"
              @click="data.app_language.value = data.loc_country.value"
              >{{ uppercase(data.loc_country.value) }}
            </span>
            <span :class="{ active: data.app_language.value === 'eng' }" @click="data.app_language.value = 'eng'">
              {{ uppercase("en") }}
            </span>
            <img src="./assets/images/mini_menu.svg" alt="Menu" @click="show_terms = true" />
          </div>
        </div>
        <div class="menu" id="main_menu">
          <div class="blue-bar"></div>
          <div class="krivina" :style="{ left: current.app_tab * 20 - 7.5 + 'vw' }">
            <img src="./assets/images/mobile/krivina.svg" alt="" />
          </div>
          <div class="top menu-bar">
            <div :class="{ tab: true, active: current.app_tab == 0 }">
              <img src="./assets/images/mobile/TAB_01_Active.svg" />
            </div>
            <div :class="{ tab: true, active: current.app_tab == 1 }">
              <img src="./assets/images/mobile/TAB_02_Active.svg" />
            </div>
            <div :class="{ tab: true, active: current.app_tab == 2 }">
              <img src="./assets/images/mobile/TAB_03_Active.svg" />
            </div>
            <div :class="{ tab: true, active: current.app_tab == 3 }">
              <img src="./assets/images/mobile/TAB_04_Active.svg" />
            </div>
            <div :class="{ tab: true, active: current.app_tab == 4 }">
              <img src="./assets/images/mobile/TAB_05_Active.svg" />
            </div>
          </div>
          <div class="bottom1 menu-bar">
            <div :class="{ tab: true, active: max_index < 0 }"></div>
            <div :class="{ tab: true, active: max_index < 1 }">
              <img src="./assets/images/mobile/TAB_02_Passive.svg" />
            </div>
            <div :class="{ tab: true, active: max_index < 2 }">
              <img src="./assets/images/mobile/TAB_03_Passive.svg" />
            </div>
            <div :class="{ tab: true, active: max_index < 3 }">
              <img src="./assets/images/mobile/TAB_04_Passive.svg" />
            </div>
            <div :class="{ tab: true, active: max_index < 4 }">
              <img src="./assets/images/mobile/TAB_05_Passive.svg" />
            </div>
          </div>
          <div class="bottom2 menu-bar">
            <div :class="{ tab: true, active: max_index >= 0 && current.app_tab != 0 }">
              <img src="./assets/images/mobile/TAB_01_Active.svg" @click="route(0)" />
            </div>
            <div :class="{ tab: true, active: max_index >= 1 && current.app_tab != 1 }">
              <img src="./assets/images/mobile/TAB_02_Active.svg" @click="route(1)" />
            </div>
            <div :class="{ tab: true, active: max_index >= 2 && current.app_tab != 2 }">
              <img src="./assets/images/mobile/TAB_03_Active.svg" @click="route(2)" />
            </div>
            <div :class="{ tab: true, active: max_index >= 3 && current.app_tab != 3 }">
              <img src="./assets/images/mobile/TAB_04_Active.svg" @click="route(3)" />
            </div>
            <div :class="{ tab: true, active: max_index >= 4 && current.app_tab != 4 }">
              <img src="./assets/images/mobile/TAB_05_Active.svg" @click="route(4)" />
            </div>
          </div>
        </div>
        <router-view
          :loc_wind="data.loc_wind"
          :app_locales="locales"
          :app_language="data.app_language"
          :app_back="data.app_back.title"
          :app_next="data.app_next.title"
          :app_confirm="data.app_confirm.title"
          :app_finish="data.app_finish.title"
          :app_start="data.app_start.title"
          :app_ok="data.app_ok.title"
          :app_delete="data.app_delete.title"
          :app_proceed="data.app_proceed.title"
          :app_cancel="data.app_cancel.title"
          :app_intervention_reset_title="data.app_intervention_reset.title"
          :app_intervention_20_21_reset_title="data.app_intervention_20_21_reset.title"
          :app_intervention_all_reset_title="data.app_intervention_all_reset.title"
          :app_intervention_20_21_all_reset_title="data.app_intervention_20_21_all_reset.title"
          :app_sklopovi_a="data.app_sklopovi_a"
          :app_sklopovi_b="data.app_sklopovi_b"
          :app_sklopovi_c="data.app_sklopovi_c"
          :app_sklopovi="data.app_sklopovi"
          :app_sklopovi_default="data.app_sklopovi_default"
          :app_tekuci_sklopovi="data.app_tekuci_sklopovi"
          :loc_sun="data.loc_sun"
          :loc_country="data.loc_country"
          :loc_city="data.loc_city"
          :loc_internal="data.loc_internal"
          :loc_reference="data.loc_reference"
          :loc_select_title="data.loc_select.title"
          :loc_additional_title="data.loc_additional.title"
          :loc_calculation_title="data.loc_calculation.title"
          :loc_hd="data.loc_hd"
          :loc_hdd="data.loc_hdd"
          :get_loc_hdd="get_loc_hdd"
          :loc_ta="data.loc_ta"
          :loc_zone="data.loc_zone"
          :loc_ti_ref="data.loc_ti_ref"
          :loc_hdd_ref="data.loc_hdd_ref"
          :get_loc_u_max="get_loc_u_max"
          :typ_select_title="data.typ_select.title"
          :typ_geometry_title="data.typ_geometry.title"
          :typ_heating_title="data.typ_heating.title"
          :app_less_parameters_title="data.app_less_parameters.title"
          :app_more_parameters_title="data.app_more_parameters.title"
          :typ_constdate="data.typ_constdate"
          :typ_floornumber="data.typ_floornumber"
          :typ_floorarea="data.typ_floorarea"
          :typ_house="data.typ_house"
          :typ_house_data="get_house_data"
          :typ_stanje="data.typ_stanje"
          :typ_grejanje="data.typ_grejanje"
          :typ_grejanje_cena="data.typ_grejanje_cena"
          :typ_grejanje_order="data.typ_grejanje_order"
          :typ_grejanje_default="data.typ_grejanje_default"
          :typ_pozicija="data.typ_pozicija"
          :typ_brojfasada="data.typ_brojfasada"
          :typ_vrstatla="data.typ_vrstatla"
          :typ_dubina="data.typ_dubina"
          :typ_window_delete="data.typ_window_delete.title"
          :typ_ceiling="data.typ_ceiling"
          :typ_data_coerce="data.typ_data_coerce.title"
          :typ_override_window="data.typ_override_window"
          :typ_override_window_manual="data.typ_override_window_manual"
          :typ_override_roof_window="data.typ_override_roof_window"
          :typ_override_roof_window_manual="data.typ_override_roof_window_manual"
          :app_height="data.app_height"
          :atc_height="data.atc_height"
          :pos_heading_title="data.pos_heading.title"
          :pos_position_select="data.pos_position.select"
          :pos_house="data.pos_house"
          :pos_status="data.pos_status"
          :pos_window="data.pos_window"
          :pos_existing_title="data.pos_existing.title"
          :pos_intervention_title="data.pos_intervention.title"
          :pos_thickness_title="data.pos_thickness.title"
          :pos_insulation_title="data.pos_insulation.title"
          :pos_intervention_on_title="data.pos_intervention_on.title"
          :pos_define_positions_title="data.pos_define_positions.title"
          :typ_house_tip_title="data.typ_house_tip.title"
          :pos_nointervention_info_title="data.pos_nointervention_info.title"
          :pos_expert_title="data.pos_expert.title"
          :pos_inside_title="data.pos_inside.title"
          :pos_above_title="data.pos_above.title"
          :pos_below_title="data.pos_below.title"
          :pos_inside_description_title="data.pos_inside_description.title"
          :pos_outside_title="data.pos_outside.title"
          :pos_outside_description_title="data.pos_outside_description.title"
          :pos_u_value_options_title="data.pos_u_value_options.title"
          :pos_u_value_low_title="data.pos_u_value_low.title"
          :pos_u_value_good_title="data.pos_u_value_good.title"
          :pos_confirm_title="data.pos_confirm.title"
          :pos_confirm_all_title="data.pos_confirm_all.title"
          :typ_select_house_title="data.typ_select_house.title"
          :pos_description_title="data.pos_description.title"
          :pos_20_21="data.pos_20_21.title"
          :pos_21_20_start="data.pos_21_20_start.title"
          :pos_21_20_delete="data.pos_21_20_delete.title"
          :pos_nagib="data.pos_nagib"
          :pos_standard="data.pos_standard"
          :pos_u_max_options_title="data.pos_u_max_options.title"
          :pos_intervention_reset="data.pos_intervention_reset.title"
          :pos_current_insulation_title="data.pos_current_insulation.title"
          :list_heading_title="data.list_heading.title"
          :list_existing_title="data.list_existing.title"
          :list_intervention_title="data.list_intervention.title"
          :calc_calculation_title="data.calc_calculation.title"
          :calc_existing_title="data.calc_existing.title"
          :calc_intervention_title="data.calc_intervention.title"
          :calc_heat_title="data.calc_heat.title"
          :calc_energy_title="data.calc_energy.title"
          :calc_offer_title="data.calc_offer.title"
          :calc_again_title="data.calc_again.title"
          :calc_consumption_title="data.calc_consumption.title"
          :calc_savings_title="data.calc_savings.title"
          :calc_disclaimer_title="data.calc_disclaimer.title"
          :app_privacy_title="data.app_privacy.title"
          :app_terms_title="data.app_terms.title"
          :app_header_title="data.app_header.title"
          :app_country_materijal="data.app_country_materijal"
          :app_country_slike="data.app_country_slike"
          :app_materijali="data.app_materijali"
          :get_ordered_construction="get_ordered_construction"
          :get_intervention_exists="get_intervention_exists"
          :get_intervention_20_21_exists="get_intervention_20_21_exists"
          :get_intervention_7_exists="get_intervention_7_exists"
          :get_all_knauf_positions_confirmed="get_all_knauf_positions_confirmed"
          :get_knauf_intervention_exists="get_knauf_intervention_exists"
          :get_sklopovi_data="get_sklopovi_data"
          :get_final_calculation="get_final_calculation"
          :get_povrsine="get_povrsine"
          :get_pos_status_u="get_pos_status_u"
          :develop="develop"
          :calc_order_value="data.calc_order.value"
          :currency_value="data.currency.value"
          :ga_gtag="data.ga_gtag.value"
          @value_change="valuechange($event)"
          @route_change="route($event)"
          @reset_status_data="reset_status_data($event)"
          @set_status_data="set_status_data($event)"
          @calculate_povrsina="set_computed('typ_povrsine_value')"
          @reset_whole_intervention="set_computed('pos_status_value')"
          @start_again="start_again()"
          :typ_mobile_carousel_click_title="data.typ_mobile_carousel_click.title"
          :typ_desktop_carousel_click_title="data.typ_desktop_carousel_click.title"
          :typ_grejanje_selected="data.typ_grejanje_selected"
        ></router-view>
      </div>
    </template>
    <vue-dekstop
      v-else
      ref="desktop"
      :app_locales="locales"
      :app_language="data.app_language"
      :get_loc_hdd="get_loc_hdd"
      :get_loc_u_max="get_loc_u_max"
      :typ_house_data="get_house_data"
      :get_ordered_construction="get_ordered_construction"
      :get_intervention_exists="get_intervention_exists"
      :get_intervention_20_21_exists="get_intervention_20_21_exists"
      :get_intervention_7_exists="get_intervention_7_exists"
      :get_sklopovi_data="get_sklopovi_data"
      :get_final_calculation="get_final_calculation"
      :get_all_knauf_positions_confirmed="get_all_knauf_positions_confirmed"
      :get_knauf_intervention_exists="get_knauf_intervention_exists"
      :get_povrsine="get_povrsine"
      :export_data="export_data"
      :get_pos_status_u="get_pos_status_u"
      :develop="develop"
      :main_data="data"
      @value-change="valuechange($event)"
      @route-change="route($event)"
      @reset-status-data="reset_status_data($event)"
      @set-status-data="set_status_data($event)"
      @calculate-povrsina="set_computed('typ_povrsine_value')"
      @reset-whole-intervention="set_computed('pos_status_value')"
      @start-again-desktop="start_again_desktop()"
    ></vue-dekstop>
    <!-- <img
      v-if="!mobile"
      class="construction"
      src="./assets/images/Desktop_under construction-01.png"
      alt="under construction"
    /> -->
  </div>
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  @include fluid-type($min_width, $max_width, $min_font, $max_font);
}

body {
  overflow-x: hidden;
}

.body-fullscreen {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.fullscreen {
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

.status-overlay {
  background: transparent;
  color: white;
  font-size: 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

@font-face {
  font-family: "F-Std";
  src: url("./assets/fonts/Futura-Boo.otf"), url("./assets/fonts/futura-boo-webfont.woff2") format("woff2"),
    url("./assets/fonts/futura-boo-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "F-Dem";
  src: url("./assets/fonts/Futura-Dem.otf"), url("./assets/fonts/futura-dem-webfont.woff2") format("woff2"),
    url("./assets/fonts/futura-dem-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: "F-Std", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .construction {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  font-size: 2rem;
  z-index: 10000;
  background-color: $main_header;

  .overlay-top-image {
    position: absolute;
    top: 28.1%;
    left: 50%;
    height: 12%;
    width: auto;
    transform: translateX(-50%);

    img {
      height: 100%;
      width: auto;
      max-height: 100%;
    }
  }

  .overlay-bottom-image {
    position: absolute;
    bottom: 6.7%;
    left: 50%;
    height: 5.3%;
    width: auto;
    transform: translateX(-50%);

    img {
      height: 100%;
      width: auto;
      max-height: 100%;
    }
  }

  .overlay-progress-full {
    position: absolute;
    top: calc(53.12% - 3px);
    height: 8px;
    left: 21%;
    width: 58%;
    border-radius: 4px;
    background-color: $main_header_light;
    z-index: 1;
  }

  .overlay-progress-bar {
    position: absolute;
    top: calc(53.12% - 3px);
    height: 8px;
    left: 21%;
    background-color: $pos_back;
    border-radius: 4px;
    z-index: 2;
  }
}

.invisible {
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
}

.main-container {
  max-width: 100%;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .terms {
    position: absolute;
    left: 2.4rem;
    right: 2.4rem;
    top: 1.8rem;
    height: 18rem;
    border-top-left-radius: 2rem;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
    overflow: hidden;
    z-index: 100000;

    .top {
      background-color: $loc_back;
      height: 5.6rem;
      color: $text_white;
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
        padding-left: 3.3rem;
        font-size: 1.8rem;
        font-weight: 500;
      }

      .right {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 1.9rem;

        img {
          width: 1.6rem;
          height: 1.6rem;
        }
      }
    }

    .bottom {
      height: 12.5rem;
      background-color: $darker_background;
      color: $main_header;
      display: flex;
      padding: 0 3rem 0 3.3rem;
      align-items: center;

      .inner {
        flex-grow: 1;

        .row {
          display: flex;
          justify-content: space-between;
          font-size: 1.8rem;

          &:first-child {
            margin-bottom: 2.1rem;
          }

          .right {
            img {
              width: 2.1rem;
              height: 2.1rem;
            }
          }
        }
      }
    }
  }

  .app-header {
    flex: 0 0 calc(20vw * 1.0526);
    background: $main_header;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @media screen and (max-width: 370px) {
      flex: 0 0 calc(20vw * 1.0526 * 0.85);
    }

    @media screen and (max-width: 320px) {
      flex: 0 0 calc(20vw * 1.0526 * 0.7);
    }

    .left {
      flex: 0 0 19vw;
      text-align: center;
    }

    .middle {
      flex: 0 0 45vw;
      padding-left: 3vw;

      img {
        width: 100%;
      }
    }

    .right {
      flex: 1 0 auto;
      margin-right: 1.8rem;
      font-size: 1.2rem;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: 0.3px;
      color: #0084a1;

      span {
        margin-left: 0.7rem;
        display: none;
      }

      img {
        margin-left: 1.5rem;
      }
    }

    .active {
      color: #ffffff;
    }
  }

  .menu {
    position: sticky;
    top: 0;
    display: flex;
    align-items: stretch;
    flex: 0 0 calc(20vw * 1.0526);
    max-height: calc(20vw * 1.0526);
    background: $lighter_background;
    z-index: 1000;
    margin-top: calc(-3vw * 1.0526);

    .blue-bar {
      background-color: $main_header;
      height: calc(6vw * 1.0526);
      width: 100%;
    }

    .krivina {
      position: absolute;
      top: calc(6vw * 1.0526 - 1.1vw);
      width: 35vw;
      height: auto;
      transition: left 0.3s ease-in-out;

      img {
        max-width: 100%;
        width: 100%;
      }
    }

    .menu-bar {
      display: flex;
      width: 100%;
      height: calc(100% - 4vw * 1.0526);
      position: absolute;

      &.bottom1,
      &.bottom2 {
        top: calc(4vw * 1.0526 + 5px);

        .tab img {
          height: 75%;
          max-height: 75%;
        }
      }

      &.bottom1 {
        .tab img {
          max-width: 50%;
        }
      }

      .tab {
        flex: 0 0 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 20%;

        img {
          height: 80%;
          max-height: 80%;
          width: auto;
          opacity: 0;
          transform-origin: center;
          transform: scale(0);
          transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
        }

        &.active img {
          opacity: 1;
          transform: scale(1);
        }
      }
    }
  }

  .tab-container {
    color: $text_dark;
    overflow-x: hidden;
    overflow-y: auto;
    height: calc(100% - 40vw);

    select {
      font-size: 1.6rem;
    }

    input {
      font-size: 1.6rem;
    }

    .vue-select-container {
      font-size: 1.6rem;
    }
  }

  .tab-footer {
    display: flex;
    background-color: $lighter_background;

    .inner {
      padding: 1.9rem 1rem;
      font-size: 2.3rem;
      flex: 0 0 50%;
      letter-spacing: 0.6px;
    }

    .left {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: $text_back;
    }

    .right {
      border-top-left-radius: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: $text_white;
    }

    span {
      position: relative;

      .arrow {
        position: absolute;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        &.left {
          right: calc(100% + 2rem);
        }

        &.right {
          left: calc(100% + 2rem);
        }
      }
    }
  }
}

select {
  border: none;
  font-family: "F-Std";
  border-radius: 10px;
  padding-left: 1rem;
  background-color: white;
  outline: none;
  background-size: 2rem 1.2rem;
  background-position: calc(100% - 0.8rem);
  appearance: none;
  background-repeat: no-repeat;
  font-size: 1.6rem;
  color: $text_select;
  font-weight: bold;
}

.main-page {
  select {
    font-family: F-Dem;
    border-radius: 1.75rem;
    font-size: 2.1rem;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: left;
    padding: 0.4rem 3rem 0.7rem 2.2rem;
    color: $text_select;
    background-size: 2.8rem 1.2rem;
    background-position: calc(100% - 1.8rem);
  }

  option {
    font-family: F-Dem;
  }

  .vue-select-container {
    font-size: 2.1rem;
  }

  select[disabled] {
    background-image: url("./assets/images/desktop/location_select_arrow_disabled.svg");
    background-color: $main_header_middle;
    color: $main_header_middle;
  }

  input {
    font-family: F-Dem;
    font-size: 2.1rem;
    line-height: 1.31;
    padding: 0.4rem 3rem 0.7rem 1.2rem;
  }

  input[disabled] {
    color: $main_header_middle;
    background-color: $main_header_middle;
    font-family: F-Std;
  }

  .input-container {
    span {
      font-size: 2.1rem;
      font-weight: bold;
      color: $text_select;

      &.disabled {
        font-size: 2.1rem;
        color: $main_header_middle;
      }
    }
  }
}

.vue-select-container {
  font-size: 1.6rem;
  color: $text_select;
  font-weight: bold;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input {
  border: 1px solid rgb(169, 169, 169);
  font-family: "F-Std";
  border-radius: 10px;
  padding-left: 0.75rem;
  background-color: white;
  outline: none;
  height: 1.55rem;
  font-size: 1.6rem;
  color: $text_select;
  font-weight: bold;
}

input[type="checkbox"] {
  padding: 0;
}
</style>

<script>
import router from "./router";
import country_data from "../data/country_data.js";
import city_data from "../data/city_data.js";
import defdata from "../data/defdata.js";
import language from "../data/language.js";
import residence from "../data/residence.js";
import helpers from "./lib/helpers.js";
import app_math from "./lib/math.js";
import Desktop from "./views/desktop_new/desktop_layout.vue";
import app_maxu from "./lib/maxu.js";
import settings from "./Settings.js";
import _ from "lodash";
import superconsole from "./lib/superconsole.js";
import mixin from "./lib/mixins.js";

export default {
  mixins: [mixin],
  components: {
    "vue-dekstop": Desktop,
  },
  router: router,
  data: function () {
    return {
      component_mounted: false,
      tabs: ["location", "type", "position", "list", "calculation"],
      residence: residence,
      country: country_data,
      city: city_data,
      language: language,
      current: { app_tab: 0 },
      data: defdata,
      mainmenu: null,
      appheader: null,
      loaded_images: [],
      loading_finished: false,
      ucitane_slike: 0,
      mobile: helpers.check_mobile(),
      max_index: 0,
      develop: settings.develop,
      show_terms: false,
      locales: {
        rs: "sr-Latn",
        bg: "bg-BG",
        ro: "ro-RO",
        gr: "el-GR",
        hr: "hr-HR",
        si: "sl-SI",
        tr: "tr-TR",
        hu: "hu-HU",
        sk: "sk-SK",
        cz: "cs-CZ",
        lt: "lt-LT",
        es: "et-EE",
        pl: "pl-PL",
      },
    };
  },
  computed: {
    get_final_calculation: function () {
      return app_math.get_final_calculation(
        this.data.typ_stanje.value,
        this.get_povrsine,
        this.get_pos_status_u,
        this.get_loc_hdd,
        this.data.loc_wind.value,
        this.data.app_sklopovi_default.data,
        this.data.typ_constdate.value,
        this.get_sklopovi_data.sklopovi,
        this.data.app_sklopovi.data,
        this.data.loc_hd.value,
        this.data.typ_floorarea.value,
        this.data.loc_sun.value,
        this.data.loc_zone.value,
        this.data.loc_country.value,
        this.data.pos_status.value,
        this.data.typ_grejanje,
        this.data.typ_grejanje_cena.data,
        this.data.typ_ceiling.value
      );
    },
    get_pos_status_u: function () {
      let u = {};
      for (const order_data of this.get_ordered_construction) {
        const key = order_data.key;
        if (key == 21 && this.data.pos_status.value["20"]) continue;
        let status = this.data.pos_status.value[key];
        let debljina_zida = Math.round(status.top_debljina_zida * 100);
        let top_debljina_izolacije_default = Math.round(status.top_debljina_izolacije_default * 100);
        let data = this.data.app_sklopovi.data;
        let res = app_math.get_final_u(
          key,
          data,
          {
            top_debljina_izolacije_default: status.top_debljina_izolacije_default,
            top_debljina_izolacije: status.top_debljina_izolacije,
            top_image: status.top_image,
            top_debljina_zida: status.top_debljina_zida,
            bottom_image: status.bottom_image,
            bottom_debljina_izolacije: status.bottom_debljina_izolacije,
          },
          debljina_zida,
          top_debljina_izolacije_default,
          this.data.typ_vrstatla,
          this.data.typ_dubina,
          this.get_povrsine.povrsina_jednog_sprata,
          this.get_povrsine.duzina_strane_kuce,
          this.data.pos_status.value["21"]
        );

        u[key] = res.u;
        if (res.u_21) {
          u["21"] = res.u_21;
          //eslint-disable-next-line
          superconsole.log(
            "u20_top: ",
            res.u.top.current,
            "u20_bottom: ",
            res.u.bottom.current,
            "u21_top: ",
            res.u_21.top.current,
            "u21_bottom",
            res.u_21.bottom.current
          );
        }
      }
      return u;
    },
    get_loc_u_max: function () {
      return app_math.get_max_u(
        this.data.loc_country.value,
        this.data.loc_zone.value,
        this.data.typ_stanje.value,
        this.data.pos_nagib.value,
        this.data.pos_status.value,
        this.get_house_data.basement >= 0,
        this.data.pos_standard.data
      );
    },
    get_all_knauf_positions_confirmed: function () {
      for (const iterator of this.get_ordered_construction) {
        if (iterator.key != "10" && iterator.key != "13" && iterator.key != "60") {
          if (!this.data.pos_status.value[iterator.key].potvrda) return false;
        }
      }
      return true;
    },
    get_knauf_intervention_exists: function () {
      for (const iterator of this.get_ordered_construction) {
        if (iterator.key != "10" && iterator.key != "13" && iterator.key != "60") {
          if (this.data.pos_status.value[iterator.key].status) return true;
        }
      }
      return false;
    },
    get_intervention_exists: function () {
      for (const key in this.data.pos_status.value) {
        if (this.data.pos_status.value.hasOwnProperty(key)) {
          if (this.data.pos_status.value[key].status === 1) return true;
        }
      }
      return false;
    },
    get_intervention_20_21_exists: function () {
      return (
        (this.data.pos_status.value["20"] && this.data.pos_status.value["20"].status === 1) ||
        (this.data.pos_status.value["21"] && this.data.pos_status.value["21"].status === 1)
      );
    },
    get_intervention_7_exists: function () {
      return this.data.pos_status.value["7"] && this.data.pos_status.value["7"].status === 1;
    },
    get_default_sklopovi_data: function () {
      const default_data = {};
      for (const key of Object.keys(this.data.app_sklopovi_default.data)) {
        const element = this.data.app_sklopovi_default.data[key];
        let fields = element.split("_");
        let position = "_" + fields[0] + "_" + fields[1];
        if (!default_data.hasOwnProperty(position)) {
          default_data[position] = [];
        }

        if (default_data[position].indexOf(fields[2]) == -1) {
          default_data[position].push(fields[2]);
        }
      }

      return default_data;
    },
    get_sklopovi_data: function () {
      let final = {};
      let combos = {};
      let defis = {};
      for (let index = 0; index < this.data.app_tekuci_sklopovi.data.length; index++) {
        const element = this.data.app_tekuci_sklopovi.data[index];
        let fields = element.substring(1).split("_");
        if (!final.hasOwnProperty(fields[0])) {
          final[fields[0]] = [];
        }

        let position = "_" + fields[0] + "_" + fields[1];
        if (final[fields[0]].indexOf(position) === -1) {
          final[fields[0]].push(position);
        }

        if (fields[2] !== undefined) {
          if (!combos.hasOwnProperty(position)) {
            combos[position] = [];
          }

          if (
            fields[2] !== "0" ||
            (this.get_default_sklopovi_data[position] && this.get_default_sklopovi_data[position].indexOf("0") !== -1)
          ) {
            if (combos[position].indexOf(fields[2]) == -1) {
              combos[position].push(fields[2]);
            }
          }

          if (fields[3] !== undefined) {
            let debljina = "_" + fields[0] + "_" + fields[1] + "_" + fields[2];
            if (!defis.hasOwnProperty(debljina)) {
              defis[debljina] = +fields[3];
            }
          }
        }
      }

      return { sklopovi: final, debljina_zida: combos, debljina_izolacije: defis };
    },
    get_house_data: function () {
      return this.data.typ_house.data[this.data.typ_house.value];
    },
    get_ordered_construction: function () {
      // sortirano je u app componenti, ovde se samo filtrira za prikazivanje
      let final = [];
      for (const key of ["1", "5", "7", "10", "13", "18", "19", "21", "20"]) {
        if (this.data.pos_position.select.hasOwnProperty(key)) {
          if (
            this.data.pos_position.data[key].Mogucnost.indexOf(this.data.typ_house.value) !== -1 &&
            this.data.app_country_pozicije.data.indexOf(key) !== -1
          ) {
            final.push({ key: key, title: this.data.pos_position.select[key] });
          }
        }
      }
      return final;
    },
    get_loc_hdd: function () {
      return app_math.get_hdd(
        this.data.loc_internal.value,
        this.data.loc_ta.value,
        this.data.loc_hd.value,
        this.data.loc_hdd_ref.value,
        this.data.loc_ti_ref.value
      );
    },
    get_povrsine: function () {
      return app_math.get_povrsine(
        this.data.typ_floorarea.value,
        this.data.typ_floornumber.value,
        this.data.app_height.value,
        this.data.atc_height.value,
        this.get_house_data.attic,
        this.get_house_data.basement,
        this.data.typ_dubina.value,
        this.data.typ_override_window.value,
        this.data.typ_override_window_manual.value,
        this.data.typ_override_roof_window.value,
        this.data.typ_override_roof_window_manual.value
      );
    },
  },
  methods: {
    export_data: function () {
      const a = document.createElement("a");
      const file = new Blob(
        [
          JSON.stringify({
            floorarea: this.data.typ_floorarea.value,
            typ_floornumber: this.data.typ_floornumber.value,
            app_height: this.data.app_height.value,
            atc_height: this.data.atc_height.value,
            house_value: this.data.typ_house.value,
            typ_dubina: this.data.typ_dubina.value,
            typ_override_window: this.data.typ_override_window.value,
            typ_override_window_manual: this.data.typ_override_window_manual.value,
            typ_override_roof_window: this.data.typ_override_roof_window.value,
            typ_override_roof_window_manual: this.data.typ_override_roof_window_manual.value,
            typ_stanje: this.data.typ_stanje.value === 2 ? "Selektovano nova kuca" : "Nije selektovano nova kuca",
            wind: this.data.loc_wind.select[this.data.loc_wind.data.indexOf(this.data.loc_wind.value)],
            construction_date: this.data.typ_constdate.data_select[
              this.data.typ_constdate.data.indexOf(this.data.typ_constdate.value)
            ],
            sun: this.data.loc_sun.select[this.data.loc_sun.data.indexOf(this.data.loc_sun.value)],
            city: this.data.loc_city.select[this.data.loc_city.value],
            heating: this.data.typ_grejanje.value,
            ceiling: this.data.typ_ceiling.select[this.data.typ_ceiling.data.indexOf(this.data.typ_ceiling.value)],
            sklopovi: this.data.pos_status.value,
          }),
        ],
        { type: "text/plain" }
      );

      a.href = URL.createObjectURL(file);
      a.download = "export_" + new Date().valueOf() + ".txt";
      a.click();

      URL.revokeObjectURL(a.href);
    },
    set_props: helpers.set_props,
    set_value: helpers.set_value,
    process_property: helpers.process_property,
    blend_operation: helpers.blend_operation,
    overwrite_operation: helpers.overwrite_operation,
    get_source_data: helpers.get_source_data,
    assign: helpers.assign,
    start_again: function () {
      this.set_computed("pos_status_value");
      this.max_index = 0;
      this.route(0);
    },
    start_again_desktop: function () {
      // this.set_props(this.data, "loc_country_value", this.data.loc_country.value);
      // this.valuechange({
      //   name: "app_height",
      //   value: this.data.app_height.value_default,
      // });
      // this.valuechange({
      //   name: "atc_height",
      //   value: this.data.atc_height.value_default,
      // });
      // this.valuechange({
      //   name: "typ_ceiling",
      //   value: this.data.typ_ceiling.value_default,
      // });
      // this.valuechange({
      //   name: "typ_dubina",
      //   value: this.data.typ_dubina.value_default,
      // });
      // this.valuechange({
      //   name: "typ_vrstatla",
      //   value: this.data.typ_vrstatla.value_default,
      // });
      // this.valuechange({
      //   name: "typ_additional_data",
      //   value: false,
      // });
      // this.valuechange({
      //   name: "loc_sun",
      //   value: this.data.loc_sun.value_default,
      // });
      // this.valuechange({
      //   name: "loc_wind",
      //   value: this.data.loc_wind.value_default,
      // });
      // this.valuechange({
      //   name: "loc_internal",
      //   value: this.data.loc_internal.value_default,
      // });
      // this.valuechange({
      //   name: "loc_additional_data",
      //   value: false,
      // });
      // this.valuechange({
      //   name: "typ_floornumber",
      //   value: this.data.typ_floornumber.value_default,
      // });
      // this.valuechange({
      //   name: "typ_floorarea",
      //   value: this.data.typ_floorarea.value_default,
      // });
      // this.set_computed("pos_status_value");
    },
    route: function (index, route) {
      this.call_gtag(index);
      this.$router.push({ name: route || this.tabs[index] });
    },
    valuechange: function (event) {
      this.data[event.name].value = _.cloneDeep(event.value);
      if (event.name == "typ_ceiling") {
        this.set_18_status_data();
      }
    },
    call_gtag: function (index) {
      const MOBILE_EXT = "(mobile)";
      let page;
      switch (index) {
        case 0:
          page = "#/location | Location";
          break;
        case 1:
          page = `#/type ${MOBILE_EXT} | House Type`;
          break;
        case 2:
          page = `#/position ${MOBILE_EXT} | Position List`;
          break;
        case 3:
          page = `#/list ${MOBILE_EXT} | Materials List`;
          break;
        case 4:
          page = `#/calculation ${MOBILE_EXT} | Calculation`;
          break;
      }
      superconsole.log(page);
      if (typeof gtag !== "undefined") {
        // eslint-disable-next-line
        gtag("config", this.data.ga_gtag.value, {
          page_path: page,
        });
      }
    },
    set_computed: function (name) {
      if (name === "typ_override_window_value") {
        this.data.typ_override_window_manual.value = false;
        this.data.typ_override_window.value = Math.round(this.get_povrsine.povrsina_prozora);
      } else if (name === "typ_grejanje_value") {
        this.data.typ_grejanje.value = this.data.typ_grejanje_default.value.toString();
      } else if (name === "typ_override_roof_window_value") {
        this.data.typ_override_roof_window_manual.value = false;
        this.data.typ_override_roof_window.value = Math.round(
          this.get_povrsine.povrsina_krovnih_prozora ? this.get_povrsine.povrsina_krovnih_prozora : 0
        );
      } else if (name === "typ_dubina_value") {
        if (!this.get_house_data) return;
        this.data.typ_dubina.value = this.get_house_data.basement === 1 ? 2 : 0;
      } else if (name === "pos_status_value") {
        this.data.pos_status.value = {};
        for (const data of this.get_ordered_construction) {
          const key = data.key;
          const new_status = this.new_status_data(key);
          this.$set(this.data.pos_status.value, "" + key, {});
          for (const new_key in new_status) {
            if (new_status.hasOwnProperty(new_key)) {
              this.$set(this.data.pos_status.value["" + key], new_key, new_status[new_key]);
            }
          }
          this.$set(this.data.pos_status.value["" + key], "title", data.title);
        }
      } else if (name === "loc_city_value") {
        this.data.loc_city.value = this.data.loc_country.data[this.data.loc_country.value]["city_value"];
      }
    },
    new_status_data: function (current_position) {
      const status = helpers.get_default_status_data(
        this.data.typ_stanje.value,
        this.data.app_sklopovi_default.data,
        current_position,
        this.data.typ_constdate.value,
        this.get_sklopovi_data,
        this.data.app_sklopovi.data,
        this.data.typ_ceiling.value,
        this.data.loc_country.value,
        this.data.app_sklopovi_a.data
      );
      return {
        // status 0 + potvrda false znaci da nije bilo intervancije i da nije potvrdjeno postojece stanje
        // status 0 + potvrda true znaci da nije bilo intervancije ali da jeste potvrdjeno postojece stanje
        // status 1 znaci da je uradjena intervencija
        status: 0,
        potvrda: false,
        top_image: status.top_image,
        top_image_default: status.top_image,
        top_debljina_izolacije: status.top_debljina_izolacije,
        top_debljina_izolacije_default: status.top_debljina_izolacije_default,
        top_debljina_zida: status.top_debljina_zida,
        bottom_image: "",
        bottom_debljina_izolacije: 0,
        laka_konstrukcija: status.laka_konstrukcija,
        tip_prozora: status.tip_prozora,
      };
    },
    set_18_status_data: function () {
      const arr = this.data.pos_status.value[18].top_image.substring(1).split("_");
      const last = arr[1] % 100;
      if (this.data.typ_ceiling.value == 1) {
        this.data.pos_status.value[18].top_image = "_" + arr[0] + "_" + last;
      } else {
        this.data.pos_status.value[18].top_image = "_" + arr[0] + "_" + (100 + last);
      }
    },
    reset_status_data: function (event) {
      const new_status = this.new_status_data(event.value);
      new_status.value = event.value;
      this.set_status_data(new_status);
    },
    set_status_data: function (event) {
      for (const key in event) {
        if (event.hasOwnProperty(key) && key !== "value") {
          this.$set(this.data.pos_status.value["" + event.value], key, event[key]);
          //this.data.pos_status.value[event.value][key] = event[key];
        }
      }
    },
    load_images: function () {
      const _that = this;
      if (this.mobile && this.loading_finished == false) {
        let count = 0,
          done = 0,
          dirty = false;

        for (const ref of this.$refs.img_cache) {
          if (!ref.complete) {
            dirty = true;
            // eslint-disable-next-line
            ref.addEventListener("load", function (event) {
              done++;
              _that.ucitane_slike = done / count;
              // eslint-disable-next-line
              // superconsole.log("Loaded - (" + done + " of " + count + ") - " + event.target.src);
              if (count === done) {
                window.setTimeout(function () {
                  _that.loading_finished = true;
                }, 200);
              }
            });
            count++;
          }
        }

        if (!dirty) {
          _that.loading_finished = true;
        }
      }
    },
    set_size: function () {
      const html = document.getElementsByTagName("html")[0];
      const body = document.getElementsByTagName("body")[0];
      const app_overlay = document.getElementById("app");
      const height = window.innerHeight;
      app_overlay.style.height = height + "px";
      body.style.height = height + "px";
      html.style.height = height + "px";
    },
    set_orientation: function () {
      let mobile = helpers.check_mobile();
      if (mobile != this.mobile) {
        this.mobile = mobile;
        this.$nextTick(function () {
          this.load_images();
          this.start_again();
        });
      }
    },
    goto_url: function (url) {
      window.open(url, "_blank");
    },
  },
  mounted: function () {
    this.component_mounted = true;
    this.route(0);
    this.mainmenu = document.getElementById("main_menu");
    this.appheader = document.getElementById("app_header");

    const _that = this;
    // let resizeTimer;
    window.addEventListener("orientationchange", function () {
      _that.set_orientation();
    });
    window.addEventListener("resize", () => {
      _that.set_size();
    });

    this.set_orientation();
    this.set_size();
  },
  created: function () {
    const _that = this;

    // kontrola
    for (const computed of Object.keys(this.data)) {
      let obj = this.data[computed];
      ["data", "data_select", "images"].forEach(function (elem) {
        if (obj[elem] != null) {
          if (obj[elem + "_trigger"]) {
            if (obj[elem + "_default"] == null)
              // eslint-disable-next-line
              superconsole.error("Trigger set, default nor set", computed, elem);
          } else {
            if (obj[elem + "_default"] != null)
              // eslint-disable-next-line
              superconsole.error("Trigger not set, default exists", computed, elem);
          }
        } else {
          if (obj[elem + "_default"] != null || obj[elem + "_trigger"] != null)
            // eslint-disable-next-line
            superconsole.error("Prop not set, default or trigger exists", computed, elem);
        }
      });
      ["title", "select"].forEach(function (elem) {
        if (obj[elem] != null) {
          if (obj[elem + "_default"] == null)
            // eslint-disable-next-line
            superconsole.error("Language prop not set, default nor set", computed, elem);
        } else {
          if (obj[elem + "_default"] != null)
            // eslint-disable-next-line
            superconsole.error("Language prop not set, default exists", computed, elem);
        }
      });

      if (obj.value == null) {
        // eslint-disable-next-line
        superconsole.info("No value", computed, "value");
      }

      if (obj.source) {
        if (obj.source !== "computed") {
          // eslint-disable-next-line
          superconsole.error("Value source when exists, has to be computed.");
        } else {
          if (obj.data_value == null && obj.watch == null)
            // eslint-disable-next-line
            superconsole.error("Value source computed and data_value and watch null", computed, "value");
          if (obj.data_value != null && obj.watch != null) {
            // eslint-disable-next-line
            superconsole.error("Both data_value and watch are set. Only one has to be set.", computed, "value");
          }
        }
      } else {
        if (obj.data_value != null || obj.watch != null)
          // eslint-disable-next-line
          superconsole.error("Value source not exists, data_value not null or watch not null", computed, "value");
      }
    }

    this.data.app_residence.value = "global";

    this.$watch(
      "data.app_residence.value",
      function (value) {
        this.set_props(this.data, "app_residence_value", value);
      },
      { immediate: true }
    );

    this.$watch(
      "data.app_language.value",
      function (value) {
        for (const prop1 of Object.keys(this.data)) {
          let obj = this.data[prop1];
          this.process_property(obj, "title", value, prop1);
          this.process_property(obj, "select", value, prop1);
        }

        this.data.typ_constdate.data_select.pop();
        this.data.typ_constdate.data_select.push(this.data.typ_stanje.title);
      },
      { immediate: true }
    );

    // function load_image(src) {
    //   let img = new Image();
    //   const p = new Promise(
    //     resolve =>
    //       function() {
    //         img.onload = function() {
    //           resolve();
    //         };
    //         window.setTimeout(function() {
    //           resolve();
    //         }, 1000);
    //       }
    //   );
    //   img.src = src;
    //   return p;
    // }

    this.$watch(
      "data.loc_country.value",
      function (value) {
        const new_images = new Set();
        this.set_props(this.data, "loc_country_value", value, this.loaded_images, new_images);
        this.data.typ_constdate.data_select.pop();
        this.data.typ_constdate.data_select.push(this.data.typ_stanje.title);

        this.data.app_language.data = [value, "eng"];
        this.data.app_language.value = value;
        ////////////////////////////////////////////////
        // ENABLE NEXT LINE FOR EAGER LOADING OF IMAGES
        ////////////////////////////////////////////////

        this.loaded_images.push(...new_images);

        ////////////////////////////////////////////////
        // ENABLE NEXT BLOCK FOR EAGER LOADING OF IMAGES
        ////////////////////////////////////////////////

        this.$nextTick(function () {
          this.load_images();
        });
      },
      { immediate: true }
    );

    this.$watch(
      "data.loc_city.value",
      function (value) {
        this.set_props(this.data, "loc_city_value", value);
      },
      { immediate: true }
    );

    for (const prop of Object.keys(this.data)) {
      let obj = this.data[prop];
      if (obj.watch && _.isArray(obj.watch)) {
        for (const watcher of obj.watch) {
          this.$watch(
            typeof watcher === "string" ? "data." + watcher + ".value" : "data." + watcher[0] + ".value." + watcher[1],
            function () {
              // eslint-disable-next-line
              superconsole.log("set computed - ", watcher, prop);
              this.set_computed(prop + "_value");
            },
            { immediate: true, deep: true }
          );
        }
      }
    }

    this.$router.beforeEach((f, t, n) => {
      if (f.name == "home" && t.name == "location") {
        window.history.back();
      } else {
        n();
      }
    });

    this.$router.afterEach((to) => {
      let index;
      if (to.name != "home") {
        index = _that.tabs.indexOf(to.name);
        this.max_index = this.max_index > index ? this.max_index : index;
        this.current.app_tab = index;
        if (this.mainmenu && this.appheader) {
          document.getElementById("app").scrollTop = 0;
        }
      }
    });

    this.$nextTick(function () {
      // function getJson(text) {
      //   if (typeof text === "string") {
      //     return text;
      //   } else {
      //     return JSON.stringify(text || "");
      //   }
      // }

      let _that = this;
      function processProperty(obj, prop1, prop_type, csv) {
        function processRow(obj, prop1, prop_type, csv, index, type) {
          let row = [];
          row[0] = prop1 + "_" + prop_type;
          row[1] = type;
          row[2] = index;
          row[3] = obj.hasOwnProperty(prop_type + "_default") ? obj[prop_type + "_default"][index] || "" : "";
          row[4] = _that.language.default.hasOwnProperty(prop1 + "_" + prop_type)
            ? _that.language.default[prop1 + "_" + prop_type][index] || ""
            : "";
          i = 5;
          for (const cur_lang of Object.keys(_that.language.default.loc_country_select)) {
            row[i] = _that.language.hasOwnProperty(cur_lang)
              ? _that.language[cur_lang].hasOwnProperty(prop1 + "_" + prop_type)
                ? _that.language[cur_lang][prop1 + "_" + prop_type][index] || ""
                : ""
              : "";
            i++;
          }
          csv.push(row);
        }

        if (typeof obj[prop_type + "_default"] === "string") {
          let row = [];
          row[0] = prop1 + "_" + prop_type;
          row[1] = "S";
          row[2] = "";
          row[3] = obj.hasOwnProperty(prop_type + "_default") ? obj[prop_type + "_default"] || "" : "";
          row[4] = _that.language.default[prop1 + "_" + prop_type] || "";
          i = 5;
          for (const cur_lang of Object.keys(_that.language.default.loc_country_select)) {
            row[i] = _that.language.hasOwnProperty(cur_lang)
              ? _that.language[cur_lang][prop1 + "_" + prop_type] || ""
              : "";
            i++;
          }
          csv.push(row);
        } else if (_.isArray(obj[prop_type + "_default"])) {
          for (const [index] of obj[prop_type + "_default"].entries()) {
            processRow(obj, prop1, prop_type, csv, index, "A");
          }
        } else if (_.isPlainObject(obj[prop_type + "_default"])) {
          for (const key in obj[prop_type + "_default"]) {
            if (obj[prop_type + "_default"].hasOwnProperty(key)) {
              processRow(obj, prop1, prop_type, csv, key, "O");
            }
          }
        }
      }

      // PREVODI PART
      let csv = [];
      let header = ["property", "type", "index", "code_default", "default"];
      let i = 5;
      for (const cur_lang of Object.keys(this.language.default.loc_country_select)) {
        header[i] = cur_lang;
        i++;
      }
      csv.push(header);
      for (const prop1 of Object.keys(this.data)) {
        if (
          prop1 === "app_sklopovi_a" ||
          prop1 === "app_sklopovi_b" ||
          prop1 === "app_sklopovi_c" ||
          prop1 === "loc_city" ||
          prop1 === "app_materijali" ||
          prop1 === "loc_country"
        )
          continue;
        let obj = this.data[prop1];
        if (obj.hasOwnProperty("title")) {
          processProperty(obj, prop1, "title", csv);
        }
        if (obj.hasOwnProperty("select")) {
          processProperty(obj, prop1, "select", csv);
        }
      }

      // eslint-disable-next-line
      superconsole.log(JSON.stringify(csv));

      // GREJANJE TEST
      let countries = ["rs", "bg", "ro", "hr", "si", "gr", "tr", "hu", "sk", "cz", "pl", "es", "lt"];
      let grejanje = [
        "ulje",
        "gas",
        "ugalj",
        "biomasa",
        "centralno",
        "kogeneracija",
        "struja",
        "antracit",
        "lignit",
        "mazut",
        "propan",
      ];
      let final = [];
      let final_co2 = [];
      for (let index = 0; index < grejanje.length; index++) {
        const ge = grejanje[index];
        let str = [ge];
        let str_co2 = [ge];
        for (let index = 0; index < countries.length; index++) {
          const ce = countries[index];
          str.push(app_maxu.get_heating_koeficijent(ce, ge));
          str_co2.push(app_maxu.get_co2_koeficijent(ce, ge));
        }
        final.push(str);
        final_co2.push(str_co2);
      }
      // eslint-disable-next-line
      // console.table(final);

      // eslint-disable-next-line
      // console.table(final_co2);

      //this.data.pos_status.value[1].top_image = "_1_1";
      //this.data.pos_status.value[1].status = 1;
      //this.max_index = 5;
      //this.route(4);
    });

    if (this.develop) {
      let country = helpers.getParameterByName("country", window.location.href);
      if (country) {
        this.data.loc_country.value = country;
      }
    } else {
      this.data.loc_country.value = settings.country;
    }

    this.data.app_language.value = this.data.loc_country.value;
  },
};
</script>
